import React from 'react';
import ExternalAuthenticationBasicInfoComponent from './external-authentication-basic-info.components';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';



function ExternalAuthenticationsComponent ({ handleInnerFormChange, onFormSubmit, chosenAuthentications }: any) {
  const tabItems=[
    {
        id:1,
        title:'External Authentications Info',
        component:  <ExternalAuthenticationBasicInfoComponent
        chosenAuthentications={chosenAuthentications}
        handleInnerFormChange={handleInnerFormChange}
        />,
    isVisible:true,
    }
  
    
  ]
  return (<>
  <div className='p-10 bg-white'>
   <form>
    <TabContainer tabItems={tabItems} />
      </form>
      <div className='text-end '>
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={onFormSubmit}
          >
            Save
          </button>
        </div>
    </div>
    </>
  );
}
export default ExternalAuthenticationsComponent;
